module.exports = __webpack_public_path__ + "static/media/Ninja-Logo.0f6e9458.svg";